export * from './ProductCardV2NutritionData';
